/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../assets/styles/pages/Shops';
import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';

import { ReactComponent as IconInfo } from '../../../assets/images/svg/utils/info.svg';

import MainShop from '../../../components/MainShop';
import { useShopContext } from '../../../providers/use-shop';
import { FormatPrice } from '../../../helpers/utils/Formating';
import { handleSaveCartStorage } from '../../../helpers/cart/product';
import { getStorege, removeStorege } from '../../../helpers/db_storage';
import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import { api } from '../../../services';
import { useLoadingContext } from '../../../providers/use-loading';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const styleModalItemMenu = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const DetailSubCategory: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { idRestaurante, id_promotion, des_promotion }: any = useParams();
  const id_shop = window.atob(idRestaurante);
  const { data }: any = useShopContext();
  const { createloading } = useLoadingContext();

  const [openModalCloseShop, setOpenModalCloseShop] = useState(false);
  const [productPromotion, setProductPromotion] = useState<any>('');
  const [productSelected, setProductSelected] = useState<any>();
  const [openModalZoonImgProduct, setOpenModalZoonImgProduct] = useState(false);

  const handleToPage = (url: string): any => {
    return navigate(url, { replace: true });
  };

  const fetchProduct = async (id: any): Promise<any> => {
    createloading(true);

    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.getMenuItensShop({
          nr_operacao: 72,
          idCardapio: id,
          idRestaurante: id_shop,
        });

      createloading(false);
      return result.data[0];
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao buscar o produto da promocão');
    }
  };

  const handleRequestProduct = async (
    id_product: number,
    type = '',
  ): Promise<any> => {
    if (data.shop?.flgFechado == 1) {
      setOpenModalCloseShop(true);
      return;
    }

    let resultProduct = data.menuSubCategory?.produtos.find(
      (product: any) => Number(product.idCardapio) === Number(id_product),
    );

    if (type === 'product-img') {
      setProductSelected(resultProduct);
      setOpenModalZoonImgProduct(true);
      return;
    }

    const resultDataCart = getStorege('@mais/delivery/shop/request/data/cart');

    if (resultDataCart?.idRestaurante != id_shop) {
      removeStorege('@mais/delivery/shop/request/data/cart');
    }

    removeStorege('@mais/delivery/shop/request/product/treat');
    if (!des_promotion && !id_promotion) {
      const result = getStorege(
        '@mais/delivery/shop/request/product/cart/promotion',
      );
      if (result) {
        toast.info('Você não finalizou a promoção, seu carrinho foi zerado.');
      }
      removeStorege('@mais/delivery/shop/request/product/cart/promotion');
    }
    if (resultProduct?.niveis?.length > 0) {
      resultProduct.optionLevelInit = 0;
    }

    if (Boolean(resultProduct) === true) {
      localStorage.setItem(
        '@mais/delivery/Shops/Menu/Product',
        JSON.stringify(resultProduct),
      );
    }

    if (id_promotion && des_promotion) {
      if (!resultProduct) {
        resultProduct = await fetchProduct(id_product);
        if (!resultProduct) {
          toast.info('Produto não encontrada');
          handleToPage(
            `/shop/detail/list/product/subcategorie/${window.btoa(id_shop)}`,
          );
          return;
        }
        if (resultProduct?.niveis?.length > 0) {
          resultProduct.optionLevelInit = 0;
        }
        localStorage.setItem(
          '@mais/delivery/Shops/Menu/Product',
          JSON.stringify(resultProduct),
        );
      }

      const resultPromotion = getStorege(
        '@mais/delivery/shop/request/product/promotion',
      );

      const product = JSON.parse(resultPromotion?.arrCardapio);
      resultProduct.idPromocao =
        product[resultPromotion.promotionCurrentStage].idPromocao;
      resultProduct.vlItem =
        product[resultPromotion.promotionCurrentStage].vlDesconto;
      resultProduct.vlDescontoItem =
        parseFloat(product[resultPromotion.promotionCurrentStage].vlItem) -
        parseFloat(product[resultPromotion.promotionCurrentStage].vlDesconto);

      resultProduct.idIncrementa =
        product[resultPromotion.promotionCurrentStage].idIncrementa;
    }
    const result = handleSaveCartStorage(
      resultProduct,
      {
        observation: '',
        incrementQt: 1,
        idShop: id_shop,
        idRestaurante,
        promotion: des_promotion || false,
        dsImagem: data?.menuSubCategory?.dsImagem || resultProduct?.dsImagem,
        promotionDeliveryFree: productPromotion?.flgFreteGratis,
      },
      'product',
      '@mais/delivery/shop/request/product/treat',
    );

    if (result?.remove) {
      toast.info('Seu carrinho expirou, por favor faça seu pedido novamente.');
    }

    if (result?.idPedidoCardapio) {
      if (Number(resultProduct.qtSabores) > 0) {
        handleToPage(
          `/shop/request/flavor/${idRestaurante}/${window.btoa(
            String(id_product),
          )}/${window.btoa(String(result?.idPedidoCardapio))}${
            id_promotion ? `/${id_promotion}/${des_promotion}` : ''
          }`,
        );
        return;
      }
      if (Number(resultProduct.qtAdicionais) > 0) {
        handleToPage(
          `/shop/request/additional/${idRestaurante}/${window.btoa(
            String(id_product),
          )}/${window.btoa(String(result?.idPedidoCardapio))}${
            id_promotion ? `/${id_promotion}/${des_promotion}` : ''
          }`,
        );
        return;
      }
      if (Number(resultProduct.flgNiveis) > 0) {
        handleToPage(
          `/shop/request/level/${idRestaurante}/${window.btoa(
            String(id_product),
          )}/${window.btoa(String(result?.idPedidoCardapio))}${
            id_promotion ? `/${id_promotion}/${des_promotion}` : ''
          }`,
        );
        return;
      }

      handleToPage(
        `/shop/request/note/${idRestaurante}/${window.btoa(
          resultProduct.idCardapio,
        )}${id_promotion ? `/${id_promotion}/${des_promotion}` : ''}`,
      );
    }
  };

  useEffect(() => {
    if (id_promotion != '' && des_promotion) {
      const result = getStorege(
        '@mais/delivery/shop/request/product/promotion',
      );

      setProductPromotion(result);
    }
  }, [des_promotion, id_promotion]);

  useEffect(() => {
    if (id_promotion != '' && des_promotion && productPromotion != '') {
      const product = JSON.parse(productPromotion.arrCardapio);

      const stage = productPromotion.promotionCurrentStage;

      handleRequestProduct(product[stage].idCardapio);
    }
  }, [des_promotion, productPromotion, id_promotion]);

  useEffect(() => {
    if (data.menuSubCategory?.produtos.length == 1 && productPromotion) {
      handleRequestProduct(
        parseInt(data.menuSubCategory?.produtos[0].idCardapio, 10),
      );
    } else if (data.menuSubCategory?.produtos.length == 1) {
      handleRequestProduct(
        parseInt(data.menuSubCategory?.produtos[0].idCardapio, 10),
      );
    }
  }, [data.menuSubCategory?.produtos, productPromotion]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      {data.shop?.idRestaurante == id_shop && (
        <>
          <Header children="Shops" />
          <CssBaseline />
          <MainShop />
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            marginBottom="100px"
          >
            {data.menuSubCategory?.produtos.length > 0 && (
              <Grid item xs={12} container justifyContent="center">
                <Grid
                  container
                  alignItems="center"
                  textAlign="left"
                  className={classeStyle.gridCategorie}
                >
                  <h5 className={classeStyle.titleCategorie}>
                    {data.menuSubCategory.dsSubCategoria}
                  </h5>
                </Grid>
                {data.menuSubCategory?.produtos.map((product: any) => (
                  <Grid
                    className={classeStyle.gridProduct}
                    container
                    item
                    justifyContent="space-between"
                    alignItems="flex-start"
                    key={product.idCardapio}
                  >
                    <Grid
                      container
                      item
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      paddingLeft="25px"
                      width="auto"
                      xs={12}
                    >
                      <Grid
                        item
                        xs={product.dsImagem ? 9 : 12}
                        sm={product.dsImagem ? 9.6 : 12}
                        className={classeStyle.gridDesProduct}
                        onClick={() =>
                          handleRequestProduct(parseInt(product.idCardapio, 10))
                        }
                      >
                        <h3 className={classeStyle.titleProduct}>
                          {product.dsNome}
                        </h3>
                        <p className={classeStyle.textProduct}>
                          {product.dsDescricao}
                        </p>
                        <Grid item>
                          <Grid container alignItems="center">
                            <p className={classeStyle.textDesValue}>
                              A partir de
                            </p>
                            <p className={classeStyle.textValue}>
                              R$ {FormatPrice(product.vlItem)}
                            </p>
                          </Grid>
                        </Grid>
                      </Grid>
                      {product.dsImagem && (
                        <Grid
                          item
                          display="flex"
                          marginRight="10px"
                          onClick={() =>
                            handleRequestProduct(
                              parseInt(product.idCardapio, 10),
                              'product-img',
                            )
                          }
                        >
                          <img
                            src={`${
                              process.env.REACT_APP_API_IMG + product.dsImagem
                            }`}
                            alt="banner"
                            className={classeStyle.bannerShop}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
          <FooterMenuMain />
        </>
      )}
      <Modal
        open={openModalCloseShop}
        onClose={() => setOpenModalCloseShop(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '750px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{
                fontWeight: '550',
                width: '100%',
                textAlign: 'center',
                margin: 0,
              }}
            >
              Atenção!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
              style={{ marginTop: 0 }}
            >
              <p>Nosso horário de funciomento é:</p>
              <p>
                Hoje das {data.shop?.horarios[0].horaAbre} às{' '}
                {data.shop?.horarios[0].horaFecha}
              </p>
              <p>Por favor, tente mais tarde</p>
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            onClick={() => setOpenModalCloseShop(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
      <Modal
        open={openModalZoonImgProduct}
        onClose={() => setOpenModalZoonImgProduct(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...styleModalItemMenu,
            background: '#fff',
            p: 2,
            border: '1px solid #e9e3e3',
          }}
        >
          <Grid
            container
            item
            textAlign="center"
            justifyContent="center"
            alignItems="center"
          >
            {productSelected && (
              <>
                {productSelected?.dsImagem && (
                  <Grid item display="flex">
                    <img
                      src={`${
                        process.env.REACT_APP_API_IMG + productSelected.dsImagem
                      }`}
                      alt="banner"
                      className={classeStyle.bannerShop}
                      style={{ width: '100%', maxWidth: 680, height: 'auto' }}
                    />
                  </Grid>
                )}
                <Grid container padding={2}>
                  <Grid item xs={9} sm={10}>
                    <h3 className={classeStyle.titleProduct}>
                      {productSelected.dsNome}
                    </h3>
                    <p className={classeStyle.textProduct}>
                      {productSelected.type === 'product' &&
                        productSelected.dsDescricao}
                    </p>
                  </Grid>

                  <Grid item xs={3} sm={2}>
                    <p className={classeStyle.textDesValue}>A partir de</p>
                    <p className={classeStyle.textValue}>
                      R$ {FormatPrice(productSelected.vlItem)}
                    </p>
                  </Grid>
                </Grid>
                <Button
                  className={classeStyle.btnSubmit}
                  onClick={() =>
                    handleRequestProduct(
                      parseInt(productSelected.idCardapio, 10),
                    )
                  }
                  variant="contained"
                >
                  Continuar
                </Button>
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </Container>
  );
};

export default DetailSubCategory;
